const buildSlideTextClones = (slide) => {
	const originalClass = "slide-text__original";

	const wrapper = slide.querySelector(".slide-text__wrapper");
	if (!wrapper) return;

	let text = wrapper.querySelector(`.${originalClass}.original`);
	let isFirstRun = false;

	if (!text) {
		text = wrapper.querySelector(`.${originalClass}`);
		if (!text) return;
		isFirstRun = true;
	}

	const isTextured = text.classList.contains("textured");
	const rectHeight = wrapper.getBoundingClientRect().height;

	if (!rectHeight || rectHeight < 10) return;

	const fontSize = rectHeight / 2 + "px";

	if (isFirstRun) {
		const original = text.cloneNode(true);
		const double = text.cloneNode(true);

		original.classList.add("original");
		double.classList.add("replica");

		if (isTextured) {
			original.classList.add("textured");
			double.classList.add("textured");
		}

		original.style.fontSize = fontSize;
		double.style.fontSize = fontSize;

		text.remove();
		wrapper.append(original);
		wrapper.append(double);
	} else {
		const replica = wrapper.querySelector(`.${originalClass}.replica`);
		text.style.fontSize = fontSize;
		if (replica) replica.style.fontSize = fontSize;
	}
};

const slideText = () => {
	const wrapperFor = (slide) => slide.querySelector(".slide-text__wrapper");


	const start = (slide, wrapper) => {

		const observer = new ResizeObserver(() => {
			buildSlideTextClones(slide);
		});
		observer.observe(wrapper);
	};

	const init = (slide, wrapper) => {
		if (document.fonts && document.fonts.ready) {
			document.fonts.ready.then(() => start(slide, wrapper));
		} else {
			start(slide, wrapper);
		}
	};

	const existingSlide = document.querySelector(".slide-text");
	const existingWrapper = existingSlide && wrapperFor(existingSlide);

	if (existingSlide && existingWrapper) {
		init(existingSlide, existingWrapper);
		return;
	}

	const domObserver = new MutationObserver(() => {
		const slide = document.querySelector(".slide-text");
		const wrapper = slide && wrapperFor(slide);
		if (slide && wrapper) {
			domObserver.disconnect();
			init(slide, wrapper);
		}
	});

	domObserver.observe(document.body, { childList: true, subtree: true });
};

const slideTextStyles = () => {
	const slide = document.querySelector(".slide-text");
	if (!slide) return;
	buildSlideTextClones(slide);
};

export { slideText, slideTextStyles };
